import React from 'react';

import Spinner from '../compUtils/Spinner';
import Icon from '../compUtils/Icon';


function ObjectModifiers(props) {

    return (
        <span>
            {
                props.editState === "READ" ?

                     props.modifiable ?
                        <div class="columns is-mobile">
                            <div class="column">
                                {props.updateConclusionState !== "NONE" && props.updateConclusionState.status === "fulfilled" ?
                                    <span class="success-fade-out"><Icon name="thumbs-up" />{" "}saved !</span>
                                    :
                                    ""
                                }
                            </div>
                            <div class="column is-narrow">
                                <a class="okwButton" onClick={props.startEdit}>
                                    <Icon name="pen" />
                                </a>
                            </div>
                        </div>
                        :
                        ""
                    : ""
            }
            {
                (props.editState === "EDIT") ?
                    <div class="columns is-mobile">
                        <div class="column">{
                            props.updateConclusionState !== "NONE" && props.updateConclusionState.status === "failure" ?
                                "saving failed: " + props.updateConclusionState.detail
                                :
                                ""
                        }</div>
                        <div class="column is-narrow">
                            <a class="okwButton" onClick={props.startSave}>
                                <Icon name="check" />
                            </a>
                        </div>
                        <div class="column is-narrow">
                            <a class="okwButton" onClick={props.startCancel}>
                                <Icon name="times" />
                            </a>
                        </div>
                    </div>
                    :
                    props.updateConclusionState === "UPDATEPENDING" ? //ENCORE ICI ??
                        <Spinner />
                        :
                        ""
            }


        </span>

    );
}

export default ObjectModifiers;
